import { nanoid } from 'nanoid'
import React, { useRef } from 'react'

import { SIZE } from './constants'
import * as S from './styles'

import { ReactComponent as RadioBulletSelected } from '../../../../assets/svgs/radio-bullet-selected.svg'
import { ReactComponent as RadioBulletUnselected } from '../../../../assets/svgs/radio-bullet-unselected.svg'

import type { RadioInputDecoupledProps } from './types'

export const RadioInputDecoupled = <T,>({
  options,
  disabled,
  className,
  darkBorder,
  size = SIZE.big,
  formLabel,
  value,
  shareWidth = true,
  isBulletDesign = false,
  ...restProps
}: RadioInputDecoupledProps<T>) => {
  const domElementId = useRef(nanoid(4))
  const isBinaryChoice = options.length === 2
  return (
    <S.RadioWrapper>
      {formLabel}
      <S.Switch
        $disabled={disabled}
        $darkBorder={darkBorder}
        className={className}
        $isBulletDesign={isBulletDesign}
      >
        {options.map((option) => (
          <React.Fragment key={option.value}>
            <S.Input
              {...restProps}
              disabled={disabled}
              type="radio"
              checked={value === option.value}
              value={option?.value}
              id={`radio-${option.value}-${domElementId.current}`}
            />
            <S.OptionLabel
              htmlFor={`radio-${option.value}-${domElementId.current}`}
              size={size}
              shareWidth={shareWidth}
            >
              {isBulletDesign ? (
                <S.BulletWrapper isChecked={value === option.value}>
                  <S.Bullet
                    size={21}
                    isChecked={value === option.value}
                    iconComponent={
                      value === option.value
                        ? RadioBulletSelected
                        : RadioBulletUnselected
                    }
                  />
                  {option?.label}
                </S.BulletWrapper>
              ) : (
                option?.label
              )}
            </S.OptionLabel>
          </React.Fragment>
        ))}
        {isBinaryChoice && !isBulletDesign && <S.Indicator size={size} />}
      </S.Switch>
    </S.RadioWrapper>
  )
}
